import useRequest from '@/websdk/utils/request';

export default (function (id) {
  //console.log('!!!!!!!!!!');
  const { data, exec } = useRequest({
    name: 'GET_USER_ROLE_LIST',
    url: `/api/system/usersroles?user_id=${id}`,
    manual: false,
  });

  return [data || [], exec];
});
